<template>
    <div class="about">
        <MainHeader/>
        <MainLogo/>
        <section style="background: #fff">
	   
       <div class="container margin_60_35">
            <div class="row col-md-12" id="contacts">
            <h4>Specials</h4>    
            <hr>
            <div class="col-md-4"  style="background: #fff; padding-left:0px;"
            v-for="special in specials.specials" :key="special.id">
                <div class="col-md-12" style="height:180px; overflow-Y: hidden">
                   <img :src="special.image" alt="" class="img-responsive" style="width: 100%">
                </div>
                <div class="col-md-12" style="margin-top:15px">
                <p><b v-text="special.title"></b></p>
                </div>
                <div class="col-md-12" v-html="special.description"></div>    
            </div>
            
            </div><!-- End row -->
        </div>
            
            
	   </section>   
    <PopUP/>
    <MainFooter/>

    </div>
     
</template>

<script>
import PreLoader from '@/components/PreLoader.vue'
import MainHeader from '@/components/MainHeader.vue'
import MainLogo from '@/components/MainLogo.vue'
import PopUP from '@/components/Popup.vue'
import MainFooter from '@/components/MainFooter.vue'
import { mapGetters } from 'vuex';
export default {
    name: 'privacyPolicy',
     components: {
        PreLoader,
        MainHeader,
        MainLogo,
        PopUP,
        MainFooter
    },
    computed: {
    ...mapGetters(['specials'])
  },
}
</script>

<style scoped>

</style>